import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconLock = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.66699 8.66683C9.66699 7.37816 10.7117 6.3335 12.0003 6.3335C13.289 6.3335 14.3337 7.37816 14.3337 8.66683V10.3335H9.66699V8.66683ZM7.66699 10.3518V8.66683C7.66699 6.2736 9.60709 4.3335 12.0003 4.3335C14.3936 4.3335 16.3337 6.2736 16.3337 8.66683V10.3518C17.8335 10.5178 19 11.7894 19 13.3335V16.6668C19 18.3237 17.6569 19.6668 16 19.6668H8C6.34315 19.6668 5 18.3237 5 16.6668V13.3335C5 11.7892 6.16685 10.5174 7.66699 10.3518ZM7 13.3335C7 12.7812 7.44772 12.3335 8 12.3335H16C16.5523 12.3335 17 12.7812 17 13.3335V16.6668C17 17.2191 16.5523 17.6668 16 17.6668H8C7.44772 17.6668 7 17.2191 7 16.6668V13.3335Z"
        />
      </svg>
    );
  }
);
